// src/pages/PasswordPagesss/PasswordPagesss.js
import React, { useState } from "react";
import { FaArrowLeft, FaLock } from "react-icons/fa";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../api/axiosInstance";
import "./PasswordPagesss.css";

const PasswordPagesss = () => {
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handlePasswordpagesssSubmit = async (e) => {
    e.preventDefault();

    if (newPass !== confirmPass) {
     alert(t("password.passwordMismatch"));
      return;
    }

    try {
      setLoading(true);

      const res = await axiosInstance.put("/admin/change-password", {
        oldPassword: currentPass,
        newPassword: newPass,
        confirmPassword: confirmPass,
      });

      alert(res?.data?.message || t("password.success"));

      setCurrentPass("");
      setNewPass("");
      setConfirmPass("");

      navigate(-1);
    } catch (error) {
      console.log("CHANGE PASSWORD ERROR:", error.response);
      alert(
        error.response?.data?.message ||
          t("password.failed")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="passwordpagesss-page">

      {/* HEADER */}
      <div className="passwordpagesss-header">
        <FaArrowLeft
          className="passwordpagesss-backicon"
          onClick={() => navigate(-1)}
        />
        <h2 className="passwordpagesss-title">
  {t("password.changeTitle")}
</h2>
      </div>

      {/* FORM CONTAINER */}
      <div className="passwordpagesss-maincontainer">
        <form
          className="passwordpagesss-form"
          onSubmit={handlePasswordpagesssSubmit}
        >

          {/* CURRENT PASSWORD */}
          <div className="passwordpagesss-field">
            <FaLock className="passwordpagesss-lefticon" />
            <input
              type={showCurrentPass ? "text" : "password"}
              placeholder={t("password.currentPassword")}
              value={currentPass}
              onChange={(e) => setCurrentPass(e.target.value)}
            />
            {showCurrentPass ? (
              <AiOutlineEye
                className="passwordpagesss-eyeicon"
                onClick={() => setShowCurrentPass(false)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className="passwordpagesss-eyeicon"
                onClick={() => setShowCurrentPass(true)}
              />
            )}
          </div>

          {/* NEW PASSWORD */}
          <div className="passwordpagesss-field">
            <FaLock className="passwordpagesss-lefticon" />
            <input
              type={showNewPass ? "text" : "password"}
              placeholder={t("password.newPassword")}
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
            />
            {showNewPass ? (
              <AiOutlineEye
                className="passwordpagesss-eyeicon"
                onClick={() => setShowNewPass(false)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className="passwordpagesss-eyeicon"
                onClick={() => setShowNewPass(true)}
              />
            )}
          </div>

          {/* CONFIRM PASSWORD */}
          <div className="passwordpagesss-field">
            <FaLock className="passwordpagesss-lefticon" />
            <input
              type={showConfirmPass ? "text" : "password"}
              placeholder={t("password.confirmPassword")}
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
            />
            {showConfirmPass ? (
              <AiOutlineEye
                className="passwordpagesss-eyeicon"
                onClick={() => setShowConfirmPass(false)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className="passwordpagesss-eyeicon"
                onClick={() => setShowConfirmPass(true)}
              />
            )}
          </div>

          <button
            className="passwordpagesss-submitbtn"
            disabled={loading}
          >
           {loading ? t("password.updating") : t("password.changeButton")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordPagesss;
